import {Component, ElementRef, inject, Input, OnInit, Renderer2} from '@angular/core';
import {Router} from '@angular/router';

// Import navigation elements
import { navigation } from './../../_nav';

@Component({
    selector: 'app-sidebar-nav',
    template: `
    <nav class="sidebar-nav">
      <ul class="nav">
        @for (navitem of navigation; track navitem) {
          @if (isDivider(navitem)) {
            <li class="nav-divider"></li>
          }
          @if (isTitle(navitem)) {
            <app-sidebar-nav-title [title]='navitem'></app-sidebar-nav-title>
          }
          @if (!isDivider(navitem)&&!isTitle(navitem)) {
            <app-sidebar-nav-item [item]='navitem'></app-sidebar-nav-item>
          }
        }
      </ul>
    </nav>`,
    standalone: false
})
export class AppSidebarNavComponent {

  public navigation = navigation;

  public isDivider(item) {
    return item.divider ? true : false
  }

  public isTitle(item) {
    return item.title ? true : false
  }
}

@Component({
    selector: 'app-sidebar-nav-item',
    template: `
    @if (!isDropdown()) {
      <li [ngClass]="hasClass() ? 'nav-item ' + item.class : 'nav-item'">
        <app-sidebar-nav-link [link]='item'></app-sidebar-nav-link>
      </li>
    } @else {
      <li [ngClass]="hasClass() ? 'nav-item nav-dropdown ' + item.class : 'nav-item nav-dropdown'"
        [class.open]="isActive()"
        routerLinkActive="open"
        appNavDropdown>
        <app-sidebar-nav-dropdown [link]='item'></app-sidebar-nav-dropdown>
      </li>
    }
    `,
    standalone: false
})
export class AppSidebarNavItemComponent {
  @Input() item: any;

  private router = inject(Router);

  public hasClass() {
    return this.item.class ? true : false
  }

  public isDropdown() {
    return this.item.children ? true : false
  }

  public thisUrl() {
    return this.item.url
  }

  public isActive() {
    return this.router.isActive(this.thisUrl(), false)
  }
}

@Component({
    selector: 'app-sidebar-nav-link',
    template: `
    @if (!isExternalLink()) {
      <a
        [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'"
        routerLinkActive="active"
        [routerLink]="[link.url]"
        (click)="hideMobile()">
        @if (isIcon()) {
          <i class="{{ link.icon }}"></i>
        }
        {{ link.name }}
        @if (isBadge()) {
          <span [ngClass]="'badge text-bg-' + link.badge.variant">{{ link.badge.text }}</span>
        }
      </a>
    } @else {
      <a [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'" href="{{link.url}}">
        @if (isIcon()) {
          <i class="{{ link.icon }}"></i>
        }
        {{ link.name }}
        @if (isBadge()) {
          <span [ngClass]="'badge text-bg-' + link.badge.variant">{{ link.badge.text }}</span>
        }
      </a>
    }
    `,
    standalone: false
})
export class AppSidebarNavLinkComponent {
  @Input() link: any;

  public hasVariant() {
    return this.link.variant ? true : false
  }

  public isBadge() {
    return this.link.badge ? true : false
  }

  public isExternalLink() {
    return this.link.url.substring(0, 4) === 'http' ? true : false
  }

  public isIcon() {
    return this.link.icon ? true : false
  }

  public hideMobile() {
    if (document.body.classList.contains('sidebar-mobile-show')) {
      document.body.classList.toggle('sidebar-mobile-show')
    }
  }
}

@Component({
    selector: 'app-sidebar-nav-dropdown',
    template: `
    <a class="nav-link nav-dropdown-toggle" [routerLink]="[link.url]" appNavDropdownToggle>
      @if (isIcon()) {
        <i class="{{ link.icon }}"></i>
      }
      {{ link.name }}
      @if (isBadge()) {
        <span [ngClass]="'badge text-bg-' + link.badge.variant">{{ link.badge.text }}</span>
      }
    </a>
    <ul class="nav-dropdown-items">
      @for (child of link.children; track child) {
        <app-sidebar-nav-item [item]='child'></app-sidebar-nav-item>
      }
    </ul>
    `,
    standalone: false
})
export class AppSidebarNavDropdownComponent {
  @Input() link: any;

  public isBadge() {
    return this.link.badge ? true : false
  }

  public isIcon() {
    return this.link.icon ? true : false
  }
}

@Component({
    selector: 'app-sidebar-nav-title',
    template: '',
    standalone: false
})
export class AppSidebarNavTitleComponent implements OnInit {
  @Input() title: any;

  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  ngOnInit() {
    const nativeElement: HTMLElement = this.el.nativeElement;
    const li = this.renderer.createElement('li');
    const name = this.renderer.createText(this.title.name);

    this.renderer.addClass(li, 'nav-title');

    if ( this.title.class ) {
      const classes = this.title.class;
      this.renderer.addClass(li, classes);
    }

    if ( this.title.wrapper ) {
      const wrapper = this.renderer.createElement(this.title.wrapper.element);

      this.renderer.appendChild(wrapper, name);
      this.renderer.appendChild(li, wrapper);
    } else {
      this.renderer.appendChild(li, name);
    }
    this.renderer.appendChild(nativeElement, li)
  }
}

export const APP_SIDEBAR_NAV = [
  AppSidebarNavComponent,
  AppSidebarNavDropdownComponent,
  AppSidebarNavItemComponent,
  AppSidebarNavLinkComponent,
  AppSidebarNavTitleComponent
];
